export function formatNotificationType(type: string): string {
  switch (type) {
    case 'newJob':
      return 'New Job';
    case 'waitlistJoin':
      return 'Waitlist Join';
    case 'quickbooksReconnect':
      return 'QuickBooks Reconnect';
    case 'cutsheetConfirmation':
      return 'Cutsheet Confirmation';
    default:
      return 'Unknown Notification Type';
  }
}
